var exports = {
  "kL": "NoteEditSheet.module__container___WnJidW",
  "Gv": "NoteEditSheet.module__backButton___WnJidW",
  "j2": "NoteEditSheet.module__backIcon___WnJidW",
  "eG": "NoteEditSheet.module__saveButton___WnJidW",
  "AW": "NoteEditSheet.module__saveButtonActive___WnJidW",
  "Qs": "NoteEditSheet.module__content___WnJidW",
  "Pf": "NoteEditSheet.module__label___WnJidW",
  "PC": "NoteEditSheet.module__textarea___WnJidW",
};

module.exports = exports;
